import React from 'react';
import { Route } from 'react-router-dom';
import {HHIEUserAuthenticatedRoute} from './components/routes/HHIEUserAuthenticatedRoute';
import {AdminAuthenticatedRoute} from './components/routes/AdminAuthenticatedRoute';
import POCAuthenticatedRoute from './components/routes/POCAuthenticatedRoute';
import { Home } from './components/Home';
import { AuthenticateUser } from './components/utility/AuthenticateUser';
import AllMembers from './components/display-members/AllMembers';
import './custom.css'
import Logout from './components/Logout';
import AdminConfig from './components/Admin/AdminConfig';
import AdminFeatures from './components/Admin/AdminFeatures';
import AdminRoles from './components/Admin/AdminRoles';
import AdminEmails from './components/Admin/AdminEmails';
import { Login } from './components/Login';
import { VerifyEmail } from './components/VerifyEmail';
import { ForgotPassword } from './components/ForgotPassword';
import { RegDashboard } from './components/registration/RegDashboard/RegDashboard';
import { AdminRegDashboard } from './components/registration/AdminRegDashboard/AdminRegDashboard';
import { MemberForm } from './components/registration/forms/MemberForm/MemberForm';
import { AccountForm } from './components/registration/forms/AccountForm';
import { POCMemberForm } from './components/registration/forms/POCMemberForm';
import { SetSecurityQuestions } from './components/registration/security-questions/SetSecurityQuestions';
import { RecoverPOCAccount } from './components/registration/security-questions/RecoverPOCAccount';
import { FalsePasswordReset } from './components/registration/security-questions/FalsePasswordReset';
import { ResetPasswordWithUUID } from './components/registration/security-questions/ResetPasswordWithUUID';
import { ResetTempPassword } from './components/ResetTempPassword';
import { ResetExpiredTemporaryPassword } from './components/Admin/ResetExpiredTemporaryPassword';
// import HHIEUserRegistrationRoute from './components/routes/HHIEUserRegistrationRoute';

const App = () => {
  
  return (
    <div>
      <Route exact path='/' component={Home} />
      <Route path='/login' component={Login} />
      <Route path='/verify-email' component={VerifyEmail} />
      <Route path='/logout' component={Logout} />
      <Route path='/authenticateUser' component={AuthenticateUser} />
      <Route path='/forgotPassword' component={ForgotPassword} />
      <Route path='/recover-account' component={RecoverPOCAccount} />
      <Route path='/set-security-questions' component={SetSecurityQuestions}/>
      <Route path='/false-password-reset' component={FalsePasswordReset} />
      <Route path='/reset-password' component={ResetPasswordWithUUID} />
      <Route path='/reset-temp-password' component={ResetTempPassword} />
      <Route path='/reset-expired-temporary-password' component={ResetExpiredTemporaryPassword} />
      <AdminAuthenticatedRoute path='/admin-config' component={AdminConfig} />
      <AdminAuthenticatedRoute path='/admin-features' component={AdminFeatures} />
      <AdminAuthenticatedRoute path='/admin-roles' component={AdminRoles} />
      <AdminAuthenticatedRoute path='/admin-emails' component={AdminEmails} />

      <HHIEUserAuthenticatedRoute path='/all-members' component={AllMembers} isRegistrationComponent={false}/>
      <HHIEUserAuthenticatedRoute path='/account-dashboard' component={AdminRegDashboard} isRegistrationComponent={true}/>
      {/* <HHIEUserRegistrationRoute path='/account-dashboard' component={AdminRegDashboard} /> */}
      
      <POCAuthenticatedRoute path='/member-form' component={MemberForm} />
      <POCAuthenticatedRoute path='/account-form' component={AccountForm} />
      <POCAuthenticatedRoute path='/poc-member-form' component={POCMemberForm} />
      <POCAuthenticatedRoute path='/registration-dashboard' component={RegDashboard} />

    </div>
  );
}
export default App;